import { FormControl, FormHelperText, Grid, Grow, Stack, Typography } from "@mui/material";
import { ScheduleImmediateButton } from "../../../schedule/components/buttons/schedule-immediate-button";
import { ScheduleSpecificButton } from "../../../schedule/components/buttons/schedule-specific-button";
import { SpecificDateTimeSelect } from "../../../schedule/components/specific-date-time-select";

import type { ISO8601_DATE, ISO8601_TIME } from "../../../../utils/iso8601";
import type { SetSchedulePayload } from "../../reducer/actions";
import type { FollowUpSchemaType } from "../../reducer/schema";
import type { FC } from "react";

interface FollowUpScheduleFinishedProps {
  value: Extract<FollowUpSchemaType, { mode: "finished" }>["schedule"];
  onChange: (val: Extract<SetSchedulePayload, { mode: "finished" }>["schedule"]) => void;
  errors: {
    schedule_type?: string;
    date?: string;
    time?: string;
    timezone?: string;
  };
  disabled: boolean;
}

export const FollowUpScheduleFinished: FC<FollowUpScheduleFinishedProps> = ({
  value,
  onChange,
  errors,
  disabled,
}) => (
  <Stack direction="column" spacing={2}>
    <FormControl error={Boolean(errors.schedule_type)}>
      <Grid container direction="row" spacing={2} justifyContent="space-between">
        <Grid size={{ xs: 12, sm: 6 }}>
          <ScheduleImmediateButton
            onClick={() => onChange({ type: "immediate" })}
            selected={value.type === "immediate"}
            subtitle="The Follow-Up will send as soon as it’s published"
            sx={{ width: "100%" }}
            disabled={disabled}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <ScheduleSpecificButton
            onClick={() =>
              onChange({
                type: "specific",
                date: null,
                time: null,
                timezone: null,
              })
            }
            selected={value.type === "specific"}
            subtitle="Set a date and time in the future to send the Follow-Up"
            sx={{ width: "100%" }}
            disabled={disabled}
          />
        </Grid>
      </Grid>
      {errors.schedule_type && <FormHelperText>{errors.schedule_type}</FormHelperText>}
    </FormControl>
    {value.type === "specific" && (
      <Grow in={value.type === "specific"}>
        <Stack direction="column" spacing={2}>
          <Typography variant="body1">Select a date and time to send</Typography>
          <SpecificDateTimeSelect
            date={{
              value: value.date,
              // oxlint-disable-next-line typescript/no-unsafe-type-assertion
              onChange: (val) => onChange({ ...value, date: val as ISO8601_DATE }),
              error: errors.date,
            }}
            time={{
              value: value.time,
              // oxlint-disable-next-line typescript/no-unsafe-type-assertion
              onChange: (val) => onChange({ ...value, time: val as ISO8601_TIME }),
              error: errors.time,
            }}
            timezone={{
              value: value.timezone,
              onChange: (val) => onChange({ ...value, timezone: val }),
              error: errors.timezone,
            }}
            disabled={disabled}
          />
        </Stack>
      </Grow>
    )}
  </Stack>
);
